<div class="row main-content">
    <div class="w15">
        <div class="sidebar">
            <ul>
                <li *ngIf="checkOVRInAgencyCode==='false'" routerLink="/dashboard/sales-home"><img src="./assets/images/home.svg"><a>Home</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToQuotePurchase()" [ngClass]="{'op5': hideQuotePurchase==='true' || agentIdActive==='false' || isDisabled}"><img src="./assets/images/quotePurchase.svg"><a>QUOTE / PURCHASE</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" routerLink="/dashboard/policy-search"><img src="./assets/images/policySearch.svg"><a>POLICY SEARCH</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToSaveQuote()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/home.svg"><a>SAVED QUOTES</a></li>
                <!-- <li routerLink="/dashboard/Groups"><img src="./assets/images/home.svg"><a>GROUPS</a></li> -->
                <li (click)="goToforms()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/file-text.svg"><a>POLICY DOCUMENTS</a></li>
                <!-- <li routerLink="/dashboard/agency-admin"><img src="./assets/images/archive.svg"><a>AGENCY ADMIN</a></li> -->
                <li routerLink="/dashboard/sales-report"><img src="./assets/images/pie-chart.svg"><a>REPORTS</a></li>
                <li class="active" (click)="goToResources()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/resources.svg"><a>RESOURCES</a></li>
            </ul>
        </div>
    </div>
    <div class="w85">
        <div class="p-3">
            <label class="bold fs-18 txt-black1">All Products</label>
            <div class="pl-3">
                <div class="regular fs-16"><a class="underline cp" href="https://travelance.app.box.com/v/plan-overview" target="_blank">Plans Overview</a></div>
                <div class="clear10"></div>
                <div class="regular fs-16 pl-2">- A descriptive overview of our plans</div>
                <div class="clear10"></div>
                <div class="regular fs-16"><a class="underline cp" href="https://travelance.app.box.com/v/all-plans-summary" target="_blank">Travelance Summary of Plans</a></div>
                <div class="clear10"></div>
                <div class="regular fs-16 pl-2">- A quick reference summary in an easy to scan table format</div>
            </div>
            <div class="clear20"></div>
            <label class="bold fs-18 txt-black1">ISP</label>
            <div class="pl-3">
                <div class="regular fs-16"><a class="underline cp" href="https://travelance.app.box.com/v/steps-to-selling-isp" target="_blank">ISP Steps to Selling Guide</a></div>
                <div class="clear10"></div>
                <div class="regular fs-16 pl-2">- A guide to selling the International Student Plan</div>
                <div class="clear10"></div>
                <div class="regular fs-16"><a class="underline cp" href="https://travelance.app.box.com/v/ISPBrochureJul24" target="_blank">ISP Brochure and Rate Chart</a></div>
                <div class="clear10"></div>
                <div class="regular fs-16 pl-2">- Review rates and unique selling points for the ISP</div>
            </div>
        </div>
        <div class="row">
            <div  class="footerBalck">
                <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10">
                    <label class="regular fs-16 m-0 txtwhite">Visitors to Canada Emergency Medical Insurance Plans, Travel Right Insurance Plans, and Student Accident Plan are underwritten by Old Republic Insurance Company of Canada. International Student Travel Insurance Policy is underwritten by Zurich Insurance Company Ltd (Canadian Branch).</label>
                </div>
            </div>
        </div>
    </div>
</div>